
import { Box, Button, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import BOTTLE_IMG from "assets/icons/bottle.svg";
import { Typography } from "components/ui";
import React from "react";
import { ActionButton, GamePaper } from "../styled";

const SpinMode = ({
    step,
    isMyTurn,
    luckyUser,
    selectedMode,
    isDone,
    handleSelectMode,
    isMobile,
    spinQuestion,
    rotationQuestion,
    spunModes,
    allQuestions,
    spinDare,
    rotationDare,
    currentDareOptions,
}) => {
    const radius = isMobile ? 65 : 140;

    return (
        <Stack spacing={2}>
            {/* Mode Selection */}
            <GamePaper active={step === 2}>
                <Box sx={{ mb: 1 }}>
                    <Typography $bolds color={step === 2 ? "primary" : "textSecondary"}>
                        2. เลือกโหมด {isMyTurn ? "(ตาคุณ!)" : ""}
                    </Typography>
                </Box>
                {!isMyTurn && luckyUser && (
                    <Typography color="error" $size="1.75em" $bolds sx={{ mb: 1 }}>
                        รอ {luckyUser.name} ตัดสินใจ...
                    </Typography>
                )}
                <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                    <ActionButton
                        variant={selectedMode === "truth" ? "contained" : "outlined"}
                        color="primary"
                        fullWidth
                        disabled={step < 2 || !isMyTurn || isDone}
                        onClick={() => handleSelectMode("truth")}
                    >
                        Truth
                    </ActionButton>
                    <ActionButton
                        variant={selectedMode === "dare" ? "contained" : "outlined"}
                        color="error"
                        fullWidth
                        disabled={step < 2 || !isMyTurn || isDone}
                        onClick={() => handleSelectMode("dare")}
                    >
                        Dare
                    </ActionButton>
                </Stack>
            </GamePaper>

            {/* Step 3: Action - Truth */}
            {selectedMode === "truth" && (
                <GamePaper active={step === 3} sx={{ border: "3px solid #ffb300" }}>
                    <Typography $bolds color="#ff8f00">
                        3. สุ่มคำถาม (Truth)
                    </Typography>
                    <Box
                        sx={{
                            position: "relative",
                            height: isMobile ? 300 : 500,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <Box
                            component="img"
                            src={BOTTLE_IMG}
                            onClick={spinQuestion}
                            sx={{
                                width: isMobile ? 100 : 200,
                                transition: "transform 3s cubic-bezier(0.15, 0, 0.15, 1)",
                                transform: `rotate(${rotationQuestion}deg)`,
                                cursor: !isMyTurn || step === 3 || spunModes.truth || isDone ? "default" : "pointer",
                                zIndex: 10,
                            }}
                        />
                        {allQuestions.map((q, i) => {
                            const angle = (i / allQuestions.length) * 2 * Math.PI - Math.PI / 2;
                            return (
                                <Box
                                    key={i}
                                    sx={{
                                        position: "absolute",
                                        transform: `translate(${Math.cos(angle) * (radius + (isMobile ? 40 : 60))
                                            }px, ${Math.sin(angle) * (radius + (isMobile ? 40 : 60))}px)`,
                                        bgcolor: "white",
                                        px: 1,
                                        py: 0.5,
                                        borderRadius: 2,
                                        border: "1px solid #ffb300",
                                        maxWidth: isMobile ? 90 : 140,
                                        fontSize: isMobile ? "1.0em" : "1.6em",
                                        boxShadow: 1,
                                        display: "-webkit-box",
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                        zIndex: 20,
                                    }}
                                >
                                    {q}
                                </Box>
                            );
                        })}
                    </Box>
                </GamePaper>
            )}

            {/* Step 3: Action - Dare */}
            {selectedMode === "dare" && (
                <GamePaper active={step === 3} sx={{ border: "3px solid #f44336" }}>
                    <Typography $bolds color="error">
                        3. สุ่มปริมาณ (Dare)
                    </Typography>
                    <Box
                        sx={{
                            position: "relative",
                            height: isMobile ? 300 : 500,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <Box
                            component="img"
                            src={BOTTLE_IMG}
                            onClick={spinDare}
                            sx={{
                                width: isMobile ? 100 : 200,
                                transition: "transform 3s cubic-bezier(0.15, 0, 0.15, 1)",
                                transform: `rotate(${rotationDare}deg)`,
                                cursor: !isMyTurn || step === 3 || spunModes.dare || isDone ? "default" : "pointer",
                                zIndex: 10,
                            }}
                        />
                        {currentDareOptions.map((opt, i) => {
                            const angle = (i / currentDareOptions.length) * 2 * Math.PI - Math.PI / 2;
                            return (
                                <Box
                                    key={i}
                                    sx={{
                                        position: "absolute",
                                        transform: `translate(${Math.cos(angle) * (radius + (isMobile ? 30 : 50))
                                            }px, ${Math.sin(angle) * (radius + (isMobile ? 30 : 50))}px)`,
                                        bgcolor: "#ffebee",
                                        px: 1,
                                        borderRadius: 2,
                                        border: "1px solid red",
                                        maxWidth: isMobile ? 80 : 120,
                                        fontSize: isMobile ? "1.3em" : "1.6em",
                                        fontWeight: "bold",
                                        boxShadow: 1,
                                        zIndex: 20,
                                    }}
                                >
                                    {opt}
                                </Box>
                            );
                        })}
                    </Box>
                </GamePaper>
            )}
        </Stack>
    );
};

export default SpinMode;
